namespace Solovis.UI.Dialogs {

    /**      
     * @property {function} selectCallback - function to call when an item is selected
     * @property {string} queryText - string to initially filter the list by
     * @property {string} title - title of the dialog window
     * @property {number} width - desired width of the dialog window
     * @property {number} height - desired height of the dialog window
     * @property {Solovis_UI_StringFilterListControl_Options} stringFilterListControlOptions - options to pass into the StringFilterListControl
     */

    export class StringFilterListDialog {

        public _selectCallback;
        public _queryText;
        public _title;
        public _width;
        public _height;
        public _showClearButton;
        public _stringFilterListControlOptions;

        public _dialogWindow: Solovis.UI.Dialog;

        public stringFilteredListControlControlHost: Solovis.UI.ControlHost;
        public stringFilteredListControl: Solovis.UI.StringFilterListControl;

        constructor(options) {
            var self = this;

            this._selectCallback = options.selectCallback ? options.selectCallback : null;
            this._queryText = options.queryText ? options.queryText : null;
            this._title = options.title ? options.title : null;
            this._width = options.width ? options.width : 600;
            this._height = options.height ? options.height : 400;

            this._showClearButton = options.showClearButton ? true : false;

            this._stringFilterListControlOptions = options.stringFilterListControlOptions ? options.stringFilterListControlOptions : null;

            var desiredWidth = Math.min($(window).width() * .8, this._width);
            var desiredHeight = Math.min($(window).height() * .8, this._height);

            var minWidth = 100;
            var minHeight = 100;

            var stringFilteredListControlControlHostDiv = $("<div>")
                .addClass("editordiv")
                .css("box-sizing", "content-box")
                .css("overflow", "hidden")
                .css("min-height", "75px");

            this.stringFilteredListControlControlHost = new Solovis.UI.ControlHost({ container: stringFilteredListControlControlHostDiv });

            this.stringFilteredListControl = new Solovis.UI.StringFilterListControl(this._stringFilterListControlOptions);

            this.stringFilteredListControlControlHost.setCurrentControl(this.stringFilteredListControl);

            if (this._queryText) {
                this.stringFilteredListControl._filterInput.setValue({ queryText: this._queryText });
                this.stringFilteredListControl._listDisplay.filter();
            }

            $(this.stringFilteredListControl).on("selectionChanged", function (e, data) {
                var selectedItem = data.item;
                if (self._selectCallback) {
                    self._selectCallback(selectedItem);
                }

                self._dialogWindow.close();
            });

            var buttons = [];

            if (this._showClearButton) {
                buttons.push({
                    label: "Clear",
                    click: function () {
                        if (self._selectCallback) {
                            self._selectCallback(null);
                        }
                        self._dialogWindow.close();
                    }
                });
            }

            buttons.push({
                label: "Cancel",
                click: function () {
                    self._dialogWindow.close();
                }
            });

            this._dialogWindow = new Solovis.UI.Dialog({
                container: stringFilteredListControlControlHostDiv,

                title: this._title,

                modal: true,
                center: true,
                actions: ["Close"],
                autoOpen: true,
                destroyOnClose: true,
                width: desiredWidth,
                minWidth: minWidth,
                minHeight: minHeight,
                height: desiredHeight,
                buttons: buttons,
                activate: function () {
                    var overallHeight = this.getAvailableContentHeight();
                    self.stringFilteredListControl.setAvailableHeight(overallHeight);
                    self.stringFilteredListControl.focusFilter();
                },

                resize: function () {
                    var overallHeight = this.getAvailableContentHeight();
                    self.stringFilteredListControl.setAvailableHeight(overallHeight);
                }
            });
        }


        public static create(options) {
            return new Solovis.UI.Dialogs.StringFilterListDialog(options);
        }

        public static showDialog = function (options) {
            var dialog = new Solovis.UI.Dialogs.StringFilterListDialog(options);
        }
    }

}


    
